export const RunModeParam = 'runMode';

export const enum RunModes {
  standalone = 'standalone',
  webappNext = 'webapp-next',
  webappStandalone = 'webapp-standalone',
}
